var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Layout',{attrs:{"type":"REVENUE","isRevenue":"true","pageTitle":_vm.$t('menu.taskStatus')}},[_c('Overview'),_c('DeviceDetail',{staticClass:"overview-device-detail"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }